import React, { useContext } from 'react';
import { redirectIFrame } from 'helpers/iframeHelpers';
import LocaleContext from 'constants/localization';
import { resToJsonHandleErrors, actionError } from 'helpers/actionHelpers';
import API from 'constants/api';

const ObjectLink = ({label, uri, link}) => {
  const LS = useContext(LocaleContext);

  if (!link) {
    return null;
  }

  const checkAccessRightsAndRedirect = uri => {
	  fetch(`${API.ACCESSRIGHTS}?uri=${uri}&rightType=read`)
      .then(resToJsonHandleErrors)
      .then(json => {
        if(json.hasAccessRights){
        	redirectIFrame(link);
        }else{
        	actionError({ message: 'accessDenied' });
        }
      });
  };
  
  const onKeyPress = e => {
    if (e.key === 'Enter' || e.key === 'Space') {
      checkAccessRightsAndRedirect(uri);
    }
  };
  
  const onClick = e => {
	  checkAccessRightsAndRedirect(uri);
  }

  return (
    <a className="action-link" tabIndex={0}
      onKeyPress={onKeyPress}
      onClick={onClick}>
      <i className="fa fa-sign-in"></i>
      {LS.actions.open} {label}
    </a>
  );
};

export default ObjectLink;